import { logUsage } from 'owa-analytics';
import { format } from 'owa-localize';
import { makePostRequest } from 'owa-ows-gateway';
import { Subtodo } from 'owa-todo-types';
import * as trace from 'owa-trace';
import { TODO_API_CREATE_SUBTASK_FORMAT } from '../utils/constants';
import getPartialSubtaskFromSubtodo from '../utils/getPartialSubtaskFromSubtodo';
import getTodoRequestHeaders from '../utils/getTodoRequestHeaders';
import { toSubtodo } from '../utils/toSubtodo';
import { CustomData } from 'owa-analytics-actions';

/**
 * Calls makePostRequest to create a new subtask
 * @param parentTaskId the parent of the subtask being created
 * @param subtask the Subtask object to create
 */
export default function createSubtaskService(
    parentTaskId: string,
    subtask: Partial<Subtodo>,
    telemetryData: CustomData
): Promise<Subtodo | null> {
    const url = format(TODO_API_CREATE_SUBTASK_FORMAT, parentTaskId);

    const subtaskToCreate = getPartialSubtaskFromSubtodo(subtask, true /*ignoreNullValues*/);
    if (!subtaskToCreate) {
        logUsage('CreateSubtaskServiceEmptyRequest', telemetryData, { isCore: true });
        return null;
    }

    return makePostRequest(
        url,
        subtaskToCreate,
        null /* correlationId */,
        false /* returnFullResponse */,
        getTodoRequestHeaders() /* customHeaders */
    )
        .then((response: any) => {
            return response ? toSubtodo(response) : null;
        })
        .catch(err => {
            trace.errorThatWillCauseAlert('[CreateSubtaskService] API returned error', err);
            return null;
        });
}
